import { state } from "../../state.js";
import { getSetting } from "../../settings.js";
import { printName } from "../../util/format.js";
import { getFlag } from "../../util/countrys.js";

export function lapStateClasses(lapState) {
  switch (lapState) {
    case 1:
      return { main: " personalFastes", opt: " personalFastesOpt" };
    case 2:
      return { main: " fastesLap", opt: " fastesLapOpt" };
    case 3:
      return { main: " pitInLap", opt: " pitInLapOpt" };
    default:
      return { main: "", opt: "" };
  }
}

function sectorColumns() {
  const columns = [];
  if (!getSetting("showSectors") || !state.noSectors) return columns;
  for (let i = 0; i < state.noSectors; i++) {
    columns.push({
      header: `SEC ${i + 1}`,
      headClass: "timeHead",
      cellClass: (row) => "timeRow" + lapStateClasses(row.sectors[i]?.lapState).main,
      render: (row) => row.sectors[i]?.time ?? "",
    });
  }
  return columns;
}

// Shared column layout for race and training rankings: identical everywhere
// except the after-leader indicator and the TOTAL time column, both race-only.
export function buildLapRankingColumns({ multiClass, includeAfterLeader, includeTotalTime }) {
  const cls = (row) => lapStateClasses(row.lapState);
  const columns = [];

  columns.push({
    key: multiClass ? "Pos" : "PosC",
    header: "POS",
    headClass: "rankHead",
    cellClass: (row) => "rankRow" + cls(row).opt,
  });
  if (multiClass && state.displayClasses) {
    columns.push({
      key: "PosC",
      header: "POS CL",
      headClass: "rankHead",
      cellClass: (row) => "rankRow" + cls(row).opt,
    });
  }
  columns.push({
    key: "STN",
    header: "NO",
    headClass: "stnHead",
    cellClass: (row) => "stnRow" + cls(row).main,
  });
  if (includeAfterLeader) {
    columns.push({
      header: "",
      headClass: "afterLeaderHead",
      cellClass: (row) => "afterLeaderRow" + cls(row).opt,
      html: true,
      render: (row) => (row.afterLeader ? `<img src="dot.png">` : ""),
    });
  }
  columns.push({
    header: "NAME",
    headClass: "nameHead",
    cellClass: (row) => "nameRow" + cls(row).main,
    html: true,
    render: (row) => printName(state.configJSON, row.names, row.Make, getFlag),
  });
  if (multiClass && state.displayClasses) {
    columns.push({
      key: "Class",
      header: "CLASS",
      headClass: "classHead",
      cellClass: (row) => "classRow" + cls(row).opt,
    });
  }
  columns.push({
    key: "Laps",
    header: "LAPS",
    headClass: "lapHead",
    cellClass: (row) => "lapRow" + cls(row).opt,
  });
  columns.push({
    key: "DiffFirst",
    header: "DIST",
    headClass: "gapHead",
    cellClass: (row) => "gapRow" + cls(row).opt,
  });
  columns.push({
    key: "DiffPrev",
    header: "GAP",
    headClass: "gapHead",
    cellClass: (row) => "gapRow" + cls(row).opt,
  });
  if (includeTotalTime && getSetting("showTotalTime")) {
    columns.push({
      key: "TotalTime",
      header: "TOTAL",
      headClass: "timeHead",
      cellClass: (row) => "timeRow" + cls(row).opt,
    });
  }
  columns.push({
    key: "Fast",
    header: "FASTEST",
    headClass: "timeHead",
    cellClass: (row) => "timeRow" + cls(row).main,
  });
  columns.push({
    key: "Last",
    header: "LAST",
    headClass: "timeHead",
    cellClass: (row) => "timeRow" + cls(row).main,
  });
  columns.push(...sectorColumns());

  return columns;
}
